// import $ from 'jquery';
import AOS from 'aos';

(() => {

  AOS.init({
    delay:100,
    duration:1000
  });

})();
